module.exports = __webpack_public_path__ + "img/google.c4dcc3e7.svg";